(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-seminars"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const oneHourInMilliseconds = 60 * 60 * 1000;
    const threeHoursInMilliseconds = 3 * 60 * 60 * 1000;

    /*
     * Seminare nach Datum sortieren:
     * kommende Seminare chronologisch oben (das naechste zuerst),
     * vergangene Seminare darunter (das juengste zuerst),
     * Seminare ohne Datum ganz unten.
     */
    const list = document.querySelector('.customer-seminars .seminar-list');

    if (list) {
      const now = Date.now();
      const getStart = (card) => {
        const time = new Date(card.dataset.seminarStart || '').getTime();
        return Number.isNaN(time) ? null : time;
      };

      const sortedCards = Array
        .from(list.querySelectorAll('.seminar-card'))
        .sort((a, b) => {
          const startA = getStart(a);
          const startB = getStart(b);

          if (startA === null && startB === null) return 0;
          if (startA === null) return 1;
          if (startB === null) return -1;

          const pastA = now >= startA + threeHoursInMilliseconds;
          const pastB = now >= startB + threeHoursInMilliseconds;

          if (pastA !== pastB) return pastA ? 1 : -1;

          return pastA ? startB - startA : startA - startB;
        });

      sortedCards.forEach((card) => list.appendChild(card));
    }

    const cards = document.querySelectorAll(
      '.customer-seminars .seminar-card[data-seminar-start]'
    );

    const updateCard = (card) => {
      const startTime = new Date(card.dataset.seminarStart).getTime();

      if (Number.isNaN(startTime)) {
        return;
      }

      const now = Date.now();
      const remainingMilliseconds = startTime - now;

      const streamButton = card.querySelector('.seminar-card__stream-button');
      const calendarButton = card.querySelector('.seminar-card__calendar-button');
      const countdown = card.querySelector('.seminar-card__countdown');
      const dateElement = card.querySelector('.seminar-card__date');
      const actions = card.querySelector('.seminar-card__actions');

      /*
       * Drei Stunden nach dem Start:
       * Datum, Countdown und Buttons ausblenden.
       */
      if (now >= startTime + threeHoursInMilliseconds) {
        if (actions) actions.hidden = true;
        if (countdown) countdown.hidden = true;
        if (dateElement) dateElement.hidden = true;
        return;
      }

      /*
       * Vor Ablauf der drei Stunden muss das Datum sichtbar sein.
       */
      if (dateElement) dateElement.hidden = false;
      if (actions) actions.hidden = false;

      /*
       * Eine Stunde vor dem Start wird der Livestream freigeschaltet.
       */
      if (streamButton && now >= startTime - oneHourInMilliseconds) {
        streamButton.href = streamButton.dataset.streamHref;
        streamButton.classList.remove('is-disabled');
        streamButton.removeAttribute('aria-disabled');
        streamButton.removeAttribute('tabindex');
      }

      /*
       * Ab Seminarbeginn wird der Kalender-Button ausgeblendet.
       */
      if (calendarButton) {
        calendarButton.hidden = now >= startTime;
      }

      if (!countdown) {
        return;
      }

      /*
       * Ab Seminarbeginn wird der Countdown ausgeblendet.
       */
      if (remainingMilliseconds <= 0) {
        countdown.hidden = true;
        return;
      }

      const totalMinutes = Math.max(0, Math.ceil(remainingMilliseconds / (60 * 1000)));
      const days = Math.floor(totalMinutes / (24 * 60));
      const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
      const minutes = totalMinutes % 60;
      const parts = [];

      if (days > 0) {
        parts.push(`${days} ${days === 1 ? 'Tag' : 'Tage'}`);
      }

      if (hours > 0 || days > 0) {
        parts.push(`${hours} ${hours === 1 ? 'Stunde' : 'Stunden'}`);
      }

      parts.push(`${minutes} ${minutes === 1 ? 'Minute' : 'Minuten'}`);

      countdown.textContent = `Noch ${parts.join(' und ')} bis zum Start`;
      countdown.hidden = false;
    };

    cards.forEach(updateCard);

    if (cards.length > 0) {
      const intervalId = window.setInterval(() => {
        const connectedCards = Array
          .from(cards)
          .filter((card) => card.isConnected);

        if (connectedCards.length === 0) {
          window.clearInterval(intervalId);
          return;
        }

        connectedCards.forEach(updateCard);
      }, 30 * 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
